import { render, staticRenderFns } from "./ProcessPalette.vue?vue&type=template&id=214a4f6d&scoped=true"
import script from "./ProcessPalette.vue?vue&type=script&lang=js"
export * from "./ProcessPalette.vue?vue&type=script&lang=js"
import style0 from "./ProcessPalette.vue?vue&type=style&index=0&id=214a4f6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214a4f6d",
  null
  
)

export default component.exports